var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('nav-search',{staticClass:"nav-bar",attrs:{"initial-search":_vm.keywords}}),_vm._v(" "),_c('div',{staticClass:"sub-page-main"},[_c('div',{staticClass:"results-col"},_vm._l((this.docsInView),function(doc){return _c('document-card',{key:doc.id,staticClass:"document-card",attrs:{"doc":doc}})}))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e863702a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Views/SearchResults.vue
// module id = 54
// module chunks = 0